import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var addUpdatePollRes;
export const addUpdatePollTodo = createAsyncThunk('addUpdatePoll', async (data) => {
    let user_id = JSON.parse(localStorage.getItem('user_data'))
    try {
        const res = await axios({

            method: "post",
            url: process.env.REACT_APP_API_URL + 'master/add_update_poll',
            data: {
                "user_id": user_id.vemp_code,
                "user_role": user_id.vrole_name,
                "created_by": user_id.vemp_code,
                "poll_id": data.id ? data.id : '',
                "poll_title": data.title,
                "description": data.description,
                "poll_options": [
                    data.opt1,
                    data.opt2,
                    data.opt3,
                    data.opt4
                ],
                "department_name": data.department,
                "status": data.status,
                "start_date": data.start_date,
                "end_date": data.end_date,
                "device_token": user_id.vdevice_token
            },
            headers: { "Content-Type": "application/json", "Authorization": 'Bearer ' + user_id.access_token }
        })
        return addUpdatePollRes = res.data
    } catch (error) {
        return addUpdatePollRes = error.response.data
    }
})